import { Flex, SkeletonText } from "@chakra-ui/react";
import "./App.css";

import { Filters } from "./components/Filters";
import useMapContext from "./hooks/useMapContext";
import { GMap } from "./components/GMap";
import ToolBar from "./components/ToolBar";

function App() {
  const mapContext = useMapContext();

  if (!mapContext.isLoaded) {
    return <SkeletonText />;
  }

  return (
    <div className="app">
      <div>
        <Flex
          position="relative"
          flexDirection="column"
          alignItems="center"
          h="100vh"
          w="100vw"
          className="map-container"
        >
          <GMap />
          <ToolBar />
          <Filters />
        </Flex>
      </div>
    </div>
  );
}

export default App;
